<template>
	<div class="wrapper">
		<side-bar>
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>របាយការណ៏</p>
			</sidebar-link>
			<sidebar-link to="/check_in">
				<md-icon>verified_user</md-icon>
				<p>Check-In អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/clients">
				<md-icon>groups</md-icon>
				<p>គ្រប់គ្រងអតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/branch">
				<md-icon>domain</md-icon>
				<p>គ្រប់គ្រងសាខា</p>
			</sidebar-link>
			<sidebar-link to="/packages">
				<md-icon>redeem</md-icon>
				<p>គ្រប់គ្រងកញ្ចប់សេវាកម្ម</p>
			</sidebar-link>
			<sidebar-link to="/administrators">
				<md-icon>supervised_user_circle</md-icon>
				<p>ការកំណត់គណនី</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue